import React from 'react';
import styled, { css } from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Column from '../../column/index';

// @TODO: size
// @TODO: color

const Icon = styled.div`
  flex-shrink: 0;
  height: 45px;
  width: 45px;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    height: 54px;
    width: 54px;
  }


  ${({ $color }) => $color !== 'default' && css`
    @supports not (mask: url()) {
      background-image: url(${({ $icon }) => $icon});
      background-size: cover;
    }
    @supports (mask: url()) {
      background-color: ${({ theme }) => {
    if ($color === 'light') {
      return 'white';
    }
    if ($color === 'dark') {
      return theme.grayDarkColor;
    }
    if ($color === 'textColor') {
      return theme.fontColor;
    }
    if ($color === 'secondary') {
      return theme.secondaryColor;
    }
    return theme.primaryColor;
  }
};
      mask: url(${({ $icon }) => $icon}) no-repeat center;
      mask-size: contain;
    }
  `}
`;

const IconBlock = ({
  columnWidth,
  align,
  justify,
  order,
  offset,
  icon,
  // size,
  color,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    order={order}
    offset={offset}
  >
    {icon?.localFile?.childImageSharp && <Image image={icon} />}
    {icon?.ext === '.svg' && <Icon $color={color} $icon={icon.url} />}
  </Column>
);

export default styled(IconBlock)``;
